<template>
  <div id="not-found" class="container" style="margin-top: 10%;">
	<div class="row">
	  <div class="col-md-6 offset-md-3">
			<h1>4<i class="fa fa-frown-o"></i>4</h1>
			<h3>Ops... Parece que a página que você tentou acessar não existe.</h3>
			<p>Redirecionando para <span v-on:click="telaInicial">página inicial</span> do sistema em <strong>{{ segundos }}</strong> segundos.</p>
	  </div>
	</div>

	<notifications group="login"/>
  </div>
</template>

<style lang="scss">
	#not-found {
		h1, h3, p {
			text-align: center;
		}

		h1 {
			font-size: 75px;
		}

		span:hover {
			color: #167495;
			text-decoration: underline;
		}

		span {
			color: #20a8d8;
			text-decoration: none;
			background-color: transparent;
			cursor: pointer;
		}
	}
</style>

<script>
	export default {
		data() {
			return {
				// Segundos para redirecionar
				segundos: 15,
			};
		},

		mounted() {
			this.setSegundos();
		},

		destroyed() {
			this.segundos = null;
		},

		methods: {
			setSegundos() {
				setTimeout(() => {
					if (this.segundos > 0) {
						this.segundos--;
						this.setSegundos();
					} 
					
					if (this.segundos === 0) {
						this.$router.push({ path: '/' });
					}
				}, 1000);
			},

			telaInicial() {
				this.$router.push({ path: '/' });
			},
		},
	}
</script>
